import { render, staticRenderFns } from "./MhExcelViewer.vue?vue&type=template&id=1af3d938&scoped=true"
import script from "./MhExcelViewer.vue?vue&type=script&lang=js"
export * from "./MhExcelViewer.vue?vue&type=script&lang=js"
import style0 from "./MhExcelViewer.vue?vue&type=style&index=0&id=1af3d938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3d938",
  null
  
)

export default component.exports